/* Event tracking from day one (doc 04 §2). Batched, best effort, never blocks the UI. */
import type { EventType } from '@tikkas/shared';
import { apiFetch } from './api.js';
import { APP_BUILD } from './platform.js';

const queue: { type: EventType; props?: Record<string, unknown>; ts: string }[] = [];
let timer: number | null = null;
let deviceId = '';
try {
  deviceId = localStorage.getItem('tikkas-anon') ?? '';
  if (!deviceId) {
    deviceId = 'anon_' + Math.random().toString(36).slice(2, 12);
    localStorage.setItem('tikkas-anon', deviceId);
  }
} catch {
  deviceId = 'anon_' + Math.random().toString(36).slice(2, 12);
}

export function track(type: EventType, props?: Record<string, unknown>): void {
  queue.push({ type, ...(props ? { props } : {}), ts: new Date().toISOString() });
  if (timer == null) timer = window.setTimeout(flush, 2500);
}

export function flush(): void {
  if (timer != null) {
    clearTimeout(timer);
    timer = null;
  }
  if (!queue.length) return;
  const events = queue.splice(0, queue.length);
  const body = JSON.stringify({ events, anonId: deviceId });
  try {
    // A beacon can't carry the app's token or key, so the app always uses fetch (keepalive survives going to the background).
    if (!APP_BUILD && document.visibilityState === 'hidden' && navigator.sendBeacon) {
      navigator.sendBeacon('/api/events', new Blob([body], { type: 'application/json' }));
      return;
    }
  } catch {
    /* fall through */
  }
  apiFetch('/api/events', { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => undefined);
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') flush();
});

/** This browser's or app's own anonymous id (kept on the device): the guest checkout's per-device abuse limit keys off it. */
export function anonId(): string {
  return deviceId;
}
